module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/ru-card-drag.040f33338b420afbb9d9.gif";